import { configQuery, getPasswordValidationRules, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata, __assign } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { sameAs } from 'vuelidate/lib/validators';

var KeycloakUpdatePassword = /** @class */ (function (_super) {
    __extends(KeycloakUpdatePassword, _super);
    function KeycloakUpdatePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Password validator conditions.
         */
        _this.passwordValidationConditions = [];
        _this.password = '';
        _this.repeatPassword = '';
        return _this;
    }
    KeycloakUpdatePassword.prototype.created = function () {
        var _this = this;
        configQuery('signup.passwordValidationConditions.DEFAULT', function (conditions) {
            if (conditions) {
                _this.passwordValidationConditions = conditions;
            }
        });
        this.sendNotification();
    };
    Object.defineProperty(KeycloakUpdatePassword.prototype, "updatePasswordAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakUpdatePassword.prototype, "repeatPasswordError", {
        get: function () {
            if (!this.$v.repeatPassword.sameAs) {
                return 'reset-password-form.confirm-password.not-same-error';
            }
            if (!this.$v.repeatPassword.validPassword) {
                return 'reset-password-form.confirm-password.error';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakUpdatePassword.prototype, "backToLoginUrl", {
        get: function () {
            return window.location.origin + this.kcContext.url.loginRestartFlowUrl;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakUpdatePassword.prototype.submit = function () {
        if (this.$v.$invalid) {
            return;
        }
        var form = this.$refs['update-password-form'];
        this.getInput(form, 'password-new').value = this.password;
        this.getInput(form, 'password-confirm').value = this.repeatPassword;
        form.submit();
    };
    KeycloakUpdatePassword.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    KeycloakUpdatePassword.prototype.sendNotification = function () {
        return this.$t('update-password.message');
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakUpdatePassword.prototype, "kcContext", void 0);
    __decorate([
        Emit('notification'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], KeycloakUpdatePassword.prototype, "sendNotification", null);
    KeycloakUpdatePassword = __decorate([
        Component({
            name: 'corex-keycloak-update-password',
            validations: function () {
                return {
                    password: __assign({}, getPasswordValidationRules(this.passwordValidationConditions)),
                    repeatPassword: __assign(__assign({}, getPasswordValidationRules(this.passwordValidationConditions)), { sameAs: sameAs('password') }),
                };
            },
        })
    ], KeycloakUpdatePassword);
    return KeycloakUpdatePassword;
}(Mixins(validationMixin, MagicConfigMixin)));

export default KeycloakUpdatePassword;
